export const routeMappings: any = {
  'My Work Items': '/myworkitems',
  'Load Management': '/loadmanagement/allloads',
  'All Loads': '/loadmanagement/allloads',
  'Load Board': '/loadmanagement/loadboard',
  'Loads Summary': '/loadmanagement/loadsummary',
  'Compliance': '/compliance',
  'Contracts': '/contracts',
  'Invoices': '/invoices',
  'Score Card': '/scorecard',
  'Settings': '/settings'
};
